const encodeQueryData = (obj) =>
    Object.entries(obj)
        .map(([key, val]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(Array.isArray(val) ? val.join(",") : val)}`
        )
        .join('&');

export default encodeQueryData;